import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'Какой формат мероприятия?',
      answer: 'Только очно, без онлайн-трансляции. Это камерная встреча для личного общения и обмена опытом.'
    },
    {
      question: 'Много ли будет мест?',
      answer: 'Нет, зал камерный с ограниченным количеством мест. Это сделано специально для создания тёплой атмосферы и возможности личного контакта с каждым участником.'
    },
    {
      question: 'Кому будет полезно участие?',
      answer: 'Неврологам, терапевтам, реабилитологам, клиническим фармакологам, алгологам и врачам смежных специальностей, работающим с коморбидными пациентами.'
    },
    {
      question: 'Нужен ли смартфон?',
      answer: 'Да, смартфон понадобится для участия в интерактивной интеллектуальной игре в конце вечера.'
    },
    {
      question: 'Какова стоимость участия?',
      answer: 'Участие бесплатное для зарегистрированных участников. Количество мест ограничено.'
    },
    {
      question: 'Будет ли фотосъёмка?',
      answer: 'Да, мероприятие будет фотографироваться с соблюдением этики и конфиденциальности участников.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-[#101A2E] mb-12 text-center" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Частые вопросы
          </h2>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
                className="bg-[#F8F7F4] rounded-xl overflow-hidden border border-[#D8B36A]/10 hover:border-[#D8B36A]/30 transition-all duration-300"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer hover:bg-[#D8B36A]/5 transition-colors duration-300"
                >
                  <span className="text-lg font-semibold text-[#101A2E] pr-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
                    {faq.question}
                  </span>
                  <i className={`ri-arrow-down-s-line text-[#D8B36A] text-2xl transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`}></i>
                </button>
                
                <AnimatePresence>
                  {openIndex === index && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className="overflow-hidden"
                    >
                      <div className="px-6 pb-5 text-base text-[#1E2430]/80 leading-relaxed text-justify">
                        {faq.answer}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}